import React, { useState } from 'react';
import { GridContainer } from '../../global';
import { FaqContainer, FaqContent, FaqTitle, FaqIntro, FaqSection, FaqItem, FaqQuestion, FaqAnswer } from './style';
import { FiChevronDown } from 'react-icons/fi';

const faqData = [
  {
    question: 'O que é a Renovera?',
    answer:(
       <div>
          <p>A Renovera é a ponte entre você, integrador, e os maiores distribuidores do mercado solar.
             Na nossa plataforma, você compara preços, condições e disponibilidade de produtos fotovoltaicos de forma instantânea — 
             e fecha negócio com total segurança.</p>
          <p>Além disso, você conta com soluções para te ajudar no dia a dia, como o Renô 
            Adviser, uma consultoria técnica especializada em Reversão de Indeferimento 
          de Projetos por Inversão de Fluxo de Potência.</p>
              </div>

          ),
  },
  {
    question: 'Como a plataforma funciona na prática?',
    answer: (
      <div>
        <p>É simples:</p>
          <li> 1 - Você cadastra seu projeto;</li>
          <li> 2 - Nossa tecnologia busca as melhores opções entre mais de 20 distribuidores;</li>
          <li> 3 - Você escolhe a oferta ideal e finaliza tudo ali mesmo — sem ligações, sem espera.</li>
      </div>
    ),
  },
  {
    question: 'A Renovera é uma loja?',
    answer: (
      <div>
        <p>Não. A gente não vende equipamentos. Nosso papel é garantir que você 
          tenha acesso às melhores condições do mercado, negociando direto com os distribuidores parceiros — 
          com a praticidade de fazer tudo em um único lugar.</p>
      </div>
    ),
  },
  {
    question: 'Preciso pagar algo para usar a plataforma?',
    answer: (
      <div>
        <p>O acesso é gratuito, sem mensalidades ou taxas escondidas.
        Você só paga quando decidir fechar uma compra — e o pagamento vai direto para a distribuidora escolhida.</p>
      </div>
    ),
  },
  {
    question: 'O que é o Renô Adviser?',
    answer: (
        <div>
            <p>É uma ferramenta exclusiva da Renovera para ajudar você a destravar projetos negados pela concessionária de energia, por Inversão de Fluxo de Potência.
            Com o Renô Adviser, nossa equipe técnica analisa a fundamentação da negativa e propõe soluções reais para viabilizar a liberação do projeto,
            de forma administrativa ou judicial. Tudo de uma maneira prática e eficiente.</p>
        </div>
    )
  },
  {
    question: 'Já tenho um orçamento. Posso comparar na plataforma?',
    answer: (
        <div>
            <p>Com certeza! Na Renovera, você pode inserir os dados do seu projeto e comparar 
              preços e condições com mais de 20 distribuidores. Assim, você tem total transparência na negociação e 
              pode tomar a melhor decisão com base em dados reais.</p>
        </div>
    )
  },
  {
    question: 'A entrega é responsabilidade da Renovera?',
    answer: <p>O transporte é realizado pela distribuidora em que os equipamentos foram adquiridos. Contudo, 
      nosso time Comercial acompanha todo o processo, desde o envio até a efetiva entrega, estando sempre disponíveis 
      para resolver qualquer contratempo.</p>
  },
  {
    question: 'Posso financiar minha compra?',
    answer: (
        <div>
            <p>Claro. Oferecemos suporte completo para quem quer financiar via instituições parceiras.
           Nosso time está pronto para te orientar, comparar opções e te ajudar a encontrar a melhor solução.</p>
        </div>
    )
  },
  {
    question: 'E se eu tiver dúvidas técnicas?',
    answer: (
        <div>
            <p>Conte com o nosso suporte!
            Estamos aqui para te ajudar na escolha de equipamentos, compatibilidade entre itens e qualquer outro ponto
            técnico que surgir no caminho.</p>
        </div>
    )
  },
  {
    question: 'Por que integradores escolhem a Renovera?',
    answer: (
      <div>
        <p>Porque:</p>
          <li>Comparam tudo em um só lugar;</li>
          <li>Conseguem negociar com mais segurança;</li>
          <li>Economizam tempo e dinheiro;</li>
          <li>Têm apoio de um time que realmente entende do seu dia a dia;</li>
          <li>É a única empresa com time técnico especializado em Reversão de Indeferimento de projetos por Inversão de Fluxo.</li>
          <li>Podem personalizar o kit com as marcas e quantidades que quiserem, direto com nosso time comercial via WhatsApp.</li>
      </div>
    ),
  },
  {
    question: 'O atendimento da Renovera é automatizado?',
    answer: (
        <div>
            <p>De jeito nenhum! Nosso atendimento é 100% humanizado. Aqui, você fala com pessoas de verdade, que entendem 
              do mercado solar e estão prontas para ajudar de forma rápida, clara e personalizada.</p>
        </div>
    )
  },
  {
    question: 'A Renovera oferece outras soluções além da compra de equipamentos?',
    answer: (
        <div>
            <p>Sim. Nosso objetivo é facilitar a vida do integrador em todas as etapas do projeto. Além do 
              acesso às melhores condições em equipamentos, também oferecemos suporte técnico e jurídico, 
              orientação sobre financiamento, acompanhamento de propostas negadas, e muito mais.</p>
        </div>
    )
  }
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <FaqContainer style={{ background: 'url(/bg-compre-agora.png)' }}>
        <GridContainer>
          <FaqContent>
            <FaqTitle>FAQ</FaqTitle>
            <FaqIntro>
              Dúvidas sobre a Renovera? Esclareça aqui as dúvidas frequentes sobre nós e sobre nosso serviço, ou entre em contato.
            </FaqIntro>
          </FaqContent>
        </GridContainer>
      </FaqContainer>
      <FaqSection>
        <GridContainer>
          {faqData.map((item, index) => (
            <FaqItem key={index}>
              <FaqQuestion onClick={() => handleToggle(index)} isOpen={openIndex === index}>
                {item.question}
                <FiChevronDown />
              </FaqQuestion>
              {openIndex === index && (
                <FaqAnswer>
                  {item.answer}
                </FaqAnswer>
              )}
            </FaqItem>
          ))}
        </GridContainer>
      </FaqSection>
    </>
  );
};

export default Faq;